import { IWFStep } from "@kuika/kuika-cl-model";

export const LOOP_STD_CONDITION_KEY = "loop.standard.condition";
export const LOOP_STD_MAX_KEY = "loop.standard.max";
export const LOOP_ITERATION_KEY = "loop.iteration";

export function getModelerSafe(): any | undefined {
  const w: any = (typeof window !== "undefined" ? window : {}) as any;
  const cands = [w.bpmnModeler, w.modeler, w.bpmnjs, w.viewer].filter(Boolean);
  for (const m of cands) {
    try {
      const er = m?.get?.("elementRegistry");
      if (er?.get) return m;
    } catch {}
  }
  return undefined;
}

export function getBpmnLoopState(stepId?: string): { enabled: boolean } {
  if (!stepId) return { enabled: false };
  const mdl = getModelerSafe();
  if (!mdl) return { enabled: false };
  try {
    const er = mdl.get("elementRegistry");
    const el = er.get(stepId);
    const lc = el?.businessObject?.loopCharacteristics;
    const enabled = !!lc && lc.$type === "bpmn:StandardLoopCharacteristics";
    return { enabled };
  } catch {
    return { enabled: false };
  }
}

function ensureExtraArray(step: any): any[] {
  if (!step.extraParameters) step.extraParameters = [] as any[];
  return step.extraParameters as any[];
}

function readJsonFromExtra(step: any, key: string): any | undefined {
  const arr = ensureExtraArray(step);
  const hit = (arr as any[]).find((p) => p?.key === key);
  if (!hit?.value) return undefined;
  try {
    return JSON.parse(hit.value);
  } catch {
    return undefined;
  }
}

async function writeJsonToExtra(sd: any, step: any, key: string, obj: any, reason?: any): Promise<void> {
  const arr = ensureExtraArray(step);
  const str = JSON.stringify(obj);
  const hit = (arr as any[]).find((p) => p?.key === key);
  if (hit) hit.value = str;
  else (arr as any[]).push({ key, value: str } as any);
  if (sd?.saveWorkFlow && sd?.selectedWf) {
    await sd.saveWorkFlow(sd.selectedWf, reason);
  }
}

export function readLoopCondition(step: IWFStep): any | undefined {
  return readJsonFromExtra(step as any, LOOP_STD_CONDITION_KEY);
}

export async function writeLoopCondition(sd: any, step: IWFStep, cond: any, reason?: any) {
  await writeJsonToExtra(sd, step as any, LOOP_STD_CONDITION_KEY, cond, reason);
}

export function readLoopMax(step: IWFStep): number | undefined {
  return readJsonFromExtra(step as any, LOOP_STD_MAX_KEY);
}

export async function writeLoopMax(sd: any, step: IWFStep, max: number, reason?: any) {
  if (max === undefined) return;
  await writeJsonToExtra(sd, step as any, LOOP_STD_MAX_KEY, max, reason);
}
